export default __webpack_public_path__ + "static/media/dfinity-logo-light-mode.4b1dc033.png";